import { GeneralCountryInformationWithNestedObjectsResponse } from 'src/app/web-api-client';
import { GeneralInformation } from '../models/general-information';

export const mapGeneralInformationFromResponse = (
  response: GeneralCountryInformationWithNestedObjectsResponse
): GeneralInformation[] => {
  const generalInformation = new GeneralInformation({
    generalCountryInformationId: response.generalCountryInformationId,
    description: response.description ?? '',
    countryId: response.country?.countryId,
    countryName: response.country?.name,
    generalCountryInformationTypeId:
      response.generalCountryInformationType?.generalCountryInformationTypeId,
    generalCountryInformationTypeName:
      response.generalCountryInformationType?.name,
    actualFrom: response.actualFrom,
    reviewDate: response.reviewDate,
    modified: response.modified,
  });
  return [generalInformation];
};
